import React, { useState } from "react";
import {
  Box,
  TextField,
  Grid,
  MenuItem,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import BackdropLoader from "../../General/Loader";
import SnackBar from "../../General/SnackBar";
import { useEffect } from "react";
import { GetAllVendorListForSelect } from "API/VendorOnboarding/api";
import { PostPurchaseOrder } from "API/PurchaseOrder/api";


const PurchaseOrder = (props) => {
  const [vendorDetails, setVendorDetails] = useState("");

  const [SelectedVendor, setSelectedVendor] = useState("")

  const [shippingCost, setShippingCost] = useState(0);
  const [taxType, setTaxType] = useState("interstate");
  const [applyIGST, setApplyIGST] = useState(true);
  const [applyCGST, setApplyCGST] = useState(true);
  const [applySGST, setApplySGST] = useState(true);
  const [billToShipTo, setBillToShipTo] = useState("billTo");
  const [shipToDetails, setShipToDetails] = useState({ name: "", mobile: "", email: "", gstno: "", address: "" });
  const [openPreview, setOpenPreview] = useState(false); // Dialog state for preview
  const [pdfUrl, setPdfUrl] = useState(null); // Blob URL for generated PDF
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [AlertOpen, setAlertOpen] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [PoDate, setPODate] = useState(new Date())

  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };



  const billTo = {
    address: "1017, JMD MEGAPOLIS, SOHNA ROAD, SECTOR 48",
    name: "Chandan Kumar Das",
    email: "Chandan.das@fiaglobal.com",
    gstin: "06AABCF9386L1Z2",
    mobile_number: "6362302795"
  }


  console.log("propsdata", props);



  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setAlertOpen(true)
  }

  const handleCloseAlert = () => {
    setAlertOpen(false)
  }


  useEffect(() => {
    GetAllVendorListForSelect(setVendorDetails, setIsLoading, handleAlertOpen)
  }, [])




  const handleVendorChange = (event) => {
    setSelectedVendor(event.target.value);
  };

  // const handleDeviceChange = (index, field, value) => {
  //   setDevices((prevDevices) =>
  //     prevDevices.map((device, i) =>
  //       i === index
  //         ? {
  //             ...device,
  //             [field]: value,
  //             total:
  //               field === "quantity"
  //                 ? (value * device.price).toFixed(2)
  //                 : device.total,
  //           }
  //         : device
  //     )
  //   );
  // };

  const calculateSubTotal = (data) => {
    let total = 0;

    if (Array.isArray(data)) {
      data.forEach((device) => {
        const amount = parseFloat(device.device_details.purchase_price) || 0;
        const quantity = parseFloat(device.quantity) || 0;
        total += amount * quantity;
      });
    }

    // Assuming shippingCost is defined in the same scope

    if (typeof shippingCost === "undefined") {
      console.error("Error: shippingCost is not defined.");
      return 0; // Handle the error gracefully
    }

    const subtotal = total + parseFloat(shippingCost);

    // console.log("subtotal",(((subtotal + Number.EPSILON) * 100) / 100).toFixed(2));
    // Ensure the result is rounded to two decimal places and returned as a float
    return (((subtotal + Number.EPSILON) * 100) / 100).toFixed(2);
  };




  const calculateTax = (amount) => {
    let igst = 0,
      cgst = 0,
      sgst = 0;
    if (taxType === "interstate" && applyIGST) {
      igst = amount * 0.18; // IGST is 18%
    } else if (taxType === "intrastate") {
      if (applyCGST) cgst = amount * 0.08; // CGST is 8%
      if (applySGST) sgst = amount * 0.10; // SGST is 10%
    }

    return {
      igst: parseFloat(igst.toFixed(2)),
      cgst: parseFloat(cgst.toFixed(2)),
      sgst: parseFloat(sgst.toFixed(2)),
    };
  };


  const handlePostPurchaseOrder = () => {
    let sub_total = calculateSubTotal(props.data.filter((item) => props.selectedItem.includes(item._id)))
    // console.log(props.data && props.data.filter((item) => props.selectedItem.includes(item._id)).map((device) => device));
    let postselected= props.data && props.data.filter((item) => props.selectedItem.includes(item._id)).map((device) => ({
      device_id:device.device_details._id,
      total_quantity:parseInt(device.quantity),
      remaining_quantity:parseInt(device.quantity),
      unit_price:parseFloat(device.device_details.purchase_price),
      total_price:eval(device.device_details.purchase_price * device.quantity)
    }))
    if (SelectedVendor && taxType && billToShipTo) {
      if (billToShipTo === 'shipTo') {
        if (shipToDetails.name !== "" && shipToDetails.email !== "" && shipToDetails.address !== "" && shipToDetails.mobile !== "" && shipToDetails.gstin !== "") {
          PostPurchaseOrder({ device_details: postselected, purchase_request_ids: props.selectedItem, vendor_id: SelectedVendor, address_type: billToShipTo, tax_type: taxType, ship_to: shipToDetails, sub_total: parseFloat(sub_total), shipping_cost: shippingCost, tax: calculateTax(sub_total), po_date: PoDate }, setIsLoading, handleAlertOpen, setOpenPreview)
        }
        else {
          handleAlertOpen("Please fill all required fields for Ship To Details", "error")
          return
        }
      }
      else {

        // console.log({ device_details: postselected, purchase_request_ids: props.selectedItem, vendor_id: SelectedVendor, address_type: billToShipTo, tax_type: taxType, bill_to: billTo, sub_total: parseFloat(sub_total), shipping_cost: shippingCost, tax: calculateTax(sub_total), po_date: PoDate });

        PostPurchaseOrder({ device_details: postselected, purchase_request_ids: props.selectedItem, vendor_id: SelectedVendor, address_type: billToShipTo, tax_type: taxType, bill_to: billTo, sub_total: parseFloat(sub_total), shipping_cost: shippingCost, tax: calculateTax(sub_total), po_date: PoDate }, setIsLoading, handleAlertOpen, setOpenPreview)
      }
    }
    else {
      handleAlertOpen("Please fill all required fields", "error")
      return
    }
  }

  const calculateTotalCost = () => {
    const subTotal = parseFloat(calculateSubTotal(props.data && props.data.filter((item) => props.selectedItem.includes(item._id))));
    const { igst, cgst, sgst } = calculateTax(subTotal);
    // const shipping = parseFloat(shippingCost || 0);

    // Total cost includes subtotal, taxes, and shipping cost
    return (subTotal + parseFloat(igst) + parseFloat(cgst) + parseFloat(sgst)).toFixed(2);
  };

  const selectedVendorFields = vendorDetails && vendorDetails.find((vendor) => vendor._id === SelectedVendor);


  const PDFGenerator = () => {
    const element = document.getElementById("purchaseOrder");
    const pageBreakElement = document.getElementById("pageBreakElement");
    const previewButton = document.getElementById("previewButton");
    const vendorselect = document.querySelectorAll("#vendorselect");
    const downloadComponent = document.getElementById("downloadButton");

    if (!element || !pageBreakElement) {
      console.error("Required elements not found.");
      return;
    }

    const padding = 10; // Padding around content in mm
    // const borderColor = "#000"; // Border color

    if (previewButton) previewButton.style.display = "none";
    if (vendorselect) vendorselect.forEach(el => el.style.display = "none");
    if (downloadComponent) downloadComponent.style.display = "none";

    html2canvas(element, { scale: 1.5, useCORS: true, scrollY: -window.scrollY,compress:true })
      .then(canvas => {
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        // const pdfHeight = pdf.internal.pageSize.getHeight();

        // const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // const imgHeight = (pdfWidth * canvasHeight) / canvasWidth;

        const pageBreakPosition = pageBreakElement.offsetTop * (canvasHeight / element.offsetHeight);

        // First part of the content before the page break
        const firstPart = canvas.getContext("2d").getImageData(0, 0, canvas.width, pageBreakPosition);
        const canvasPart1 = document.createElement("canvas");
        canvasPart1.width = canvas.width;
        canvasPart1.height = pageBreakPosition;
        canvasPart1.getContext("2d").putImageData(firstPart, 0, 0);

        // Draw page with padding and border for the first part
        // pdf.setDrawColor(borderColor);
        // pdf.rect(padding, padding, pdfWidth - 2 * padding, pdfHeight - 2 * padding); // Draw border
        pdf.addImage(
          canvasPart1.toDataURL("image/png",0.5),
          "PNG",
          padding,
          padding,
          pdfWidth - 2 * padding,
          (pdfWidth * pageBreakPosition) / canvas.width
        );

        pdf.addPage();

        // Second part of the content after the page break
        const secondPart = canvas.getContext("2d").getImageData(0, pageBreakPosition, canvas.width, canvasHeight - pageBreakPosition);
        const canvasPart2 = document.createElement("canvas");
        canvasPart2.width = canvas.width;
        canvasPart2.height = canvasHeight - pageBreakPosition;
        canvasPart2.getContext("2d").putImageData(secondPart, 0, 0);

        // Draw page with padding and border for the second part
        // pdf.setDrawColor(borderColor);
        // pdf.rect(padding, padding, pdfWidth - 2 * padding, pdfHeight - 2 * padding); // Draw border
        pdf.addImage(
          canvasPart2.toDataURL("image/png",0.5),
          "PNG",
          padding,
          padding,
          pdfWidth - 2 * padding,
          (pdfWidth * (canvasHeight - pageBreakPosition)) / canvas.width
        );

        // Generate Blob URL for preview
        const blob = pdf.output("blob",{compress:true});
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setOpenPreview(true);
      })
      .catch(err => console.error("Error generating PDF:", err))
      .finally(() => {
        if (previewButton) previewButton.style.display = "block";
        if (downloadComponent) downloadComponent.style.display = "inline";
        if (vendorselect) vendorselect.forEach(el => el.style.display = "block");
      });
  }



  // pdf generator
  const generatePDF = () => {
    if (billToShipTo?.trim().toLowerCase() === "shipto") {
      if (!shipToDetails) {
        handleAlertOpen("Shipping details are missing", "error");
        return false;
      }

      const { name, email, address, gstno, mobile } = shipToDetails;

      if (!name?.trim()) {
        handleAlertOpen("Please fill the name field under shipping details", "error");
        return false;
      }



      if (!mobile?.trim() || mobile.length < 10 || !/^\d+$/.test(mobile)) {
        handleAlertOpen("Please fill a valid mobile field under shipping details", "error");
        return false;
      }

      if (!email?.trim()) {
        handleAlertOpen("Please fill the email field under shipping details", "error");
        return false;
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        handleAlertOpen("Please enter a valid email address under shipping details", "error");
        return false;
      }



      if (!gstno?.trim()) {
        handleAlertOpen("Please fill the GST No field under shipping details", "error");
        return false;
      }

      if (!address?.trim()) {
        handleAlertOpen("Please fill the address field under shipping details", "error");
        return false;
      }

      // All validations passed
      PDFGenerator();
    } else {
      PDFGenerator();
    }
  };





  const handleChangeShipToDetails = (key, event) => {
    console.log("key", key);

    if (key === "name") {
      if (/^[a-zA-Z\s]*$/.test(event.target.value)) {
        setShipToDetails({
          ...shipToDetails,
          [key]: event.target.value,
        })
      }
    }
    else if (key === "mobile") {
      if (/^[0-9]*$/.test(event.target.value) && event.target.value.length < 11) {
        setShipToDetails({
          ...shipToDetails,
          [key]: event.target.value,
        })
      }
    }
    else if (key === "email") {
      if (/^[0-9a-zA-Z@_.]*$/.test(event.target.value)) {
        setShipToDetails({
          ...shipToDetails,
          [key]: event.target.value,
        })
      }
    }
    else if (key === "gstno") {
      if (/^[0-9a-zA-Z]*$/.test(event.target.value)) {
        setShipToDetails({
          ...shipToDetails,
          [key]: event.target.value,
        }
        )
      }
    }
    else if (key === "address") {
      if (/^[0-9a-zA-Z\s/,]*$/.test(event.target.value)) {
        setShipToDetails({
          ...shipToDetails,
          [key]: event.target.value,
        })

      }

    }
  }


  return (
    <Box id="purchaseOrder" p={3} sx={{ breakInside: 'avoid' }}>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleCloseAlert} />
      <Typography variant="h4" gutterBottom>
        Purchase Order
      </Typography>

      <Card variant="outlined">
        <CardContent>
          {/* Purchase Order Details */}
          <Grid container spacing={2} flexDirection="column">

            <Grid item xs={4}>
              <TextField sx={{ display: 'none' }} disabled label="Purchase Order ID" fullWidth size="small" variant="standard" />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Purchase Request Id"
                fullWidth
                size="small"
                variant="standard"
                value={props.data && props.data.filter((item) => props.selectedItem.includes(item._id)).reverse().map((item) => item.purchase_request_id)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={
                  {
                    readOnly: true,
                  }
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="PO Date"
                value={formatDate(PoDate)}
                type="date" onChange={(e) => setPODate(e.target.value)}
                fullWidth
                size="small"
                variant="standard"
                inputProps={
                  {
                    readOnly: true,
                  }
                }
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          {/* Vendor Details and Bill To Address Side by Side */}
          <Box mt={3}>
            <Grid container spacing={2}>
              <Grid container spacing={2} padding={2}>
                <Grid item xs={4} id="vendorselect">
                  <TextField
                    id="vendorselect"
                    select
                    label="Vendor Name"
                    variant="standard"
                    fullWidth
                    size="small"
                    value={SelectedVendor}
                    onChange={handleVendorChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {vendorDetails && vendorDetails.map((item, index) => (
                      <MenuItem key={index} value={item._id}>{item.vendor_name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h6">Order To</Typography>

                <Card variant="outlined" style={{ maxHeight: "100%", minHeight: 100, overflow: "auto" }}>
                  <CardContent>
                    <Grid container spacing={2}>

                      {selectedVendorFields &&
                        <>
                          <Grid item xs={12}>
                            <TextField
                              label="Company Name"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.company_name}

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Contact Name/ID"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.vendor_name}

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Address"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.address}

                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              label="City"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.district}

                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              label="Pincode"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.pin_code}

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Mobile Number"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.mobile_number}

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="GSIT No"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.gst_number}

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Email"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={selectedVendorFields.email_address}

                            />
                          </Grid>
                        </>

                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="h6">Order By</Typography>

                <Card variant="outlined" style={{ maxHeight: "100%", minHeight: 100, overflow: "auto" }}>
                  <CardContent>
                    <Grid container spacing={2}>
                      {selectedVendorFields ? (
                        <>
                          <Grid item xs={12} >
                            <TextField
                              label="Contact Name"
                              fullWidth
                              size="small"
                              value="Chandan Kumar Das"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              label="Company Name"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="FIA TECHNOLOGY SERVICES PVT LTD"

                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              label="Address"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="1017, JMD MEGAPOLIS, SOHNA ROAD, SECTOR 48"

                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              label="City"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="Gurugram"

                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="Pincode"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="122018"

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Mobile Number"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="6362302795"

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="GST No."
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="06AABCF9386L1Z2"

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Email"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={{
                                readOnly: true,
                              }}
                              value="Chandan.das@fiaglobal.com"

                            />
                          </Grid>
                        </>
                      ) : (
                        <Grid item xs={12}>
                          <Typography></Typography>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Device Details */}
          <Box mt={3}>
            <Typography variant="h6">Device Details</Typography>
            <Card variant="outlined">
              <CardContent>
                <TableContainer component={Paper}>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell>Brand Name</TableCell>
                        <TableCell>Device Name</TableCell>
                        <TableCell>Model Number</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {

                        props.data && props.data.filter((item) => props.selectedItem.includes(item._id)).map((device, index) => (
                          <TableRow key={index}>
                            <TableCell>{device.device_details.brand_name}</TableCell>
                            <TableCell>{device.device_details.name}</TableCell>
                            <TableCell>{device.device_details.model}</TableCell>
                            <TableCell>
                              {device.quantity}
                            </TableCell>
                            <TableCell>₹{device.device_details.purchase_price?device.device_details.purchase_price:"-"}</TableCell>
                            <TableCell>₹{device.device_details.purchase_price?eval(device.device_details.purchase_price * device.quantity):"-"}</TableCell>
                          </TableRow>
                        ))


                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Box>


          {/* Tax Section & Shipping Cost */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Tax & Shipping Cost
            </Typography>
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={3}>
                  {/* Tax Type Selection */}
                  <Grid item xs={6}>
                    <TextField
                      select
                      label="Tax Type"
                      fullWidth
                      size="small"
                      value={taxType}
                      variant="standard"
                      onChange={(e) => {
                        setTaxType(e.target.value);
                        // Do not reset already applied taxes to preserve selections
                      }}
                    >
                      <MenuItem value="interstate">Interstate</MenuItem>
                      <MenuItem value="intrastate">Intrastate</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Interstate Tax (IGST) */}
                  {taxType === "interstate" && (
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={applyIGST}
                            onChange={(e) => setApplyIGST(e.target.checked)}
                          />
                        }
                        label="IGST (18%)"
                      />
                    </Grid>
                  )}

                  {/* Intrastate Tax (CGST & SGST on the same line) */}
                  {taxType === "intrastate" && (
                    <Grid item xs={12}>
                      <Grid container spacing={1} alignItems="center">
                        {/* CGST Checkbox */}
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={applyCGST}
                                onChange={(e) => setApplyCGST(e.target.checked)}
                              />
                            }
                            label="CGST (8%)"
                          />
                        </Grid>

                        {/* SGST Checkbox */}
                        <Grid item xs={6} sx={{ ml: -45 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={applySGST}
                                onChange={(e) => setApplySGST(e.target.checked)}
                              />
                            }
                            label="SGST (10%)"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/* Shipping Cost */}
                  <Grid item xs={6}>
                    <TextField
                      label="Shipping Cost"
                      type="text"
                      size="small"
                      variant="standard"
                      disabled
                      value={shippingCost}
                      onChange={(e) => /^[0-9]*$/.test(e.target.value) && setShippingCost(parseFloat(e.target.value) || 0)}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>



          {/* Invoice Summary */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Invoice Summary
            </Typography>
            <Card variant="outlined" sx={{ backgroundColor: "#f9f9f9", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* Subtotal */}
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="body1" fontWeight="bold">
                        Subtotal:
                      </Typography>
                      <Typography variant="body1">₹{calculateSubTotal(props.data && props.data.filter((item) => props.selectedItem.includes(item._id)))}</Typography>
                    </Box>
                  </Grid>

                  {/* Tax Details */}
                  {applyIGST && taxType === "interstate" && (
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body1" fontWeight="bold">
                          IGST (18%):
                        </Typography>
                        <Typography variant="body1">₹{calculateTax(calculateSubTotal(props.data && props.data.filter((item) => props.selectedItem.includes(item._id)))).igst.toFixed(2)}</Typography>
                      </Box>
                    </Grid>
                  )}
                  {applyCGST && taxType === "intrastate" && (
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body1" fontWeight="bold">
                          CGST (8%):
                        </Typography>
                        <Typography variant="body1">₹{calculateTax(calculateSubTotal(props.data && props.data.filter((item) => props.selectedItem.includes(item._id)))).cgst.toFixed(2)}</Typography>
                      </Box>
                    </Grid>
                  )}
                  {applySGST && taxType === "intrastate" && (
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body1" fontWeight="bold">
                          SGST (10%):
                        </Typography>
                        <Typography variant="body1">₹{calculateTax(calculateSubTotal(props.data && props.data.filter((item) => props.selectedItem.includes(item._id)))).sgst.toFixed(2)}</Typography>
                      </Box>
                    </Grid>
                  )}

                  {/* Divider */}
                  <Divider sx={{ width: "100%", my: 2 }} />

                  {/* Total Cost */}
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h6" fontWeight="bold">
                        Total Cost:
                      </Typography>
                      <Typography variant="h6" fontWeight="bold" color="secondary">
                        ₹{calculateTotalCost()}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>




          <div id="pageBreakElement"></div>



          {/* Bill To / Ship To Section */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Bill To / Ship To
            </Typography>
            <Card variant="outlined" sx={{ p: 3 }}>
              {/* Header Section */}
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                <TextField
                  select
                  label="Bill To / Ship To"
                  size="small"
                  value={billToShipTo}
                  variant="standard"
                  onChange={(e) => setBillToShipTo(e.target.value)}
                  sx={{ minWidth: "200px" }}
                >
                  <MenuItem value="billTo">Bill To</MenuItem>
                  <MenuItem value="shipTo">Ship To</MenuItem>
                </TextField>
              </Box>

              <Grid container spacing={4} alignItems="flex-start">
                {/* Billing Details Section */}
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    {billToShipTo === "billTo" ? "Billing Details" : "Shipping Details"}
                  </Typography>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      {billToShipTo === "billTo" ? (
                        <>
                          {/* First Row */}
                          <Grid item xs={6}>
                            <TextField
                              label="Name"
                              size="small"
                              fullWidth
                              variant="standard"
                              value="Chandan Kumar Das"
                              inputProps={
                                {
                                  readOnly: true
                                }
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="Mobile Number"
                              size="small"
                              fullWidth
                              variant="standard"
                              value="6362302795"
                              inputProps={
                                {
                                  readOnly: true
                                }
                              }
                            />
                          </Grid>

                          {/* Second Row */}
                          <Grid item xs={6}>
                            <TextField
                              label="Email ID"
                              size="small"
                              fullWidth
                              variant="standard"
                              value="Chandan.das@fiaglobal.com"
                              inputProps={
                                {
                                  readOnly: true
                                }
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="GSTIN No."
                              size="small"
                              fullWidth
                              variant="standard"
                              value="06AABCF9386L1Z2"
                              inputProps={
                                {
                                  readOnly: true
                                }
                              }
                            />
                          </Grid>

                          {/* Third Row */}
                          <Grid item xs={6}>
                            <TextField
                              label="Address"
                              size="small"
                              fullWidth
                              variant="standard"
                              value="1017, JMD MEGAPOLIS, SOHNA ROAD, SECTOR 48"
                              inputProps={
                                {
                                  readOnly: true
                                }
                              }
                            />
                          </Grid>
                        </>
                      ) : (
                        Object.keys(shipToDetails).map((key) => (
                          <Grid item xs={6} key={key}>
                            <TextField
                              label={key.charAt(0).toUpperCase() + key.slice(1)}
                              size="small"
                              fullWidth
                              variant="standard"
                              value={shipToDetails[key]}
                              onChange={(e) =>
                                handleChangeShipToDetails(key, e)
                              }
                            />
                          </Grid>
                        ))
                      )}
                    </Grid>
                  </Card>
                </Grid>

                {/* Bank Details Section */}
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Bank Details
                  </Typography>
                  <Card
                    variant="outlined"
                    sx={{
                      p: 3,
                      backgroundColor: "#f9f9f9",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <TextField
                          label="Bank Name"
                          size="small"
                          fullWidth
                          variant="standard"
                          value={selectedVendorFields?.bank_name}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: { backgroundColor: "#fff", borderRadius: "4px" },
                          }}
                          InputLabelProps={
                            {
                              shrink: true,
                            }
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Account Name"
                          size="small"
                          fullWidth
                          variant="standard"
                          value={selectedVendorFields?.bank_account_name}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }

                          InputLabelProps={
                            {
                              shrink: true,
                            }
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Account Number"
                          size="small"
                          fullWidth
                          variant="standard"
                          value={selectedVendorFields?.bank_account_number}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputLabelProps={
                            {
                              shrink: true,
                            }
                          }

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="IFSC Code"
                          size="small"
                          fullWidth
                          variant="standard"
                          value={selectedVendorFields?.ifsc_code}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: { backgroundColor: "#fff", borderRadius: "4px" },
                          }}
                          InputLabelProps={
                            {
                              shrink: true,
                            }
                          }
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

              </Grid>
            </Card>
          </Box>

          {/* Terms and Conditions Section */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Terms and Conditions
            </Typography>
            <Card
              variant="outlined"
              sx={{
                p: 3,
                backgroundColor: "#f9f9f9",
                boxShadow: "0 4px 8px rgba(36, 168, 63, 0.1)",
                borderRadius: "12px",
                border: "1px solid #24A83F",
              }}
            >
              <CardContent>
                <Typography variant="body2" gutterBottom sx={{ lineHeight: 1.6 }}>
                  <strong>1.</strong> Delivery time period is 10 days from the date of payment released.
                </Typography>
                <Typography variant="body2" gutterBottom sx={{ lineHeight: 1.6 }}>
                  <strong>2.</strong> Dispatch of devices shall be strictly on the basis of Advanced payment only. Apart from this, there shall not be any other clause applicable.
                </Typography>

              </CardContent>
            </Card>
          </Box>


          {/* Preview button */}
          <Box mt={3}>
            <Button id="previewButton" variant="contained" color="secondary" disabled={(!SelectedVendor || SelectedVendor === "") ? true : false} onClick={generatePDF}>
              Preview
            </Button>
          </Box>

          {/* Preview Dialog */}
          <Dialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
            maxWidth="lg"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: '12px',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                border: '1px solid #e0e0e0',
              },
            }}
          >
            <DialogTitle
              sx={{
                fontWeight: 'bold',
                fontSize: '1.25rem',
                borderBottom: '1px solid #e0e0e0',
                padding: '16px 24px',
              }}
            >
              Purchase Order Preview
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpenPreview(false)}
                sx={{
                  float: 'right',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  fontSize: '0.875rem',
                }}
              >
                Close
              </Button>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: 0,
                backgroundColor: '#f9f9f9',
              }}
            >
              {pdfUrl ? (
                <iframe
                  src={pdfUrl}
                  title="Purchase Order Preview"
                  width="100%"
                  height="600px"
                  style={{
                    border: 'none',
                    padding: '16px',
                  }}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  padding="16px"
                >
                  <Typography variant="body1" color="textSecondary">
                    No preview available.
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '16px 24px',
                borderTop: '1px solid #e0e0e0',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
                onClick={() => {
                  // Add submit logic here
                  console.log('Submit clicked!');
                  handlePostPurchaseOrder()
                  setOpenPreview(false); // Close the dialog after submission
                }}
              >
                Submit
              </Button>
            </Box>
          </Dialog>
        </CardContent>
      </Card>

    </Box>
  );
};

export default PurchaseOrder;
